import { Translation } from "@/data/lang";

export type NavigationLink = {
  name: string;
  anchor: string;
};

export const getOverviewLinks = ({
  t,
}: {
  t: Translation;
}): NavigationLink[] => [
  { name: t.analysis.navigation.AIAnalysis, anchor: "analysis" },
  { name: t.analysis.navigation.performance, anchor: "current-performance" },
  { name: t.analysis.navigation.top10Relevance, anchor: "top-10-relevance" },
  { name: t.analysis.navigation.profile, anchor: "profile" },
  { name: t.analysis.navigation.price, anchor: "price" },
];

export const getValueLinks = ({ t }: { t: Translation }): NavigationLink[] => [
  { name: t.analysis.navigation.analysisInstructions, anchor: "analysis" },
  { name: t.analysis.navigation.referenceFactors, anchor: "reference-factor" },
  { name: t.analysis.navigation.forecast, anchor: "financial-forecast" },
  { name: t.analysis.navigation.revenue, anchor: "earnings-table" },
  { name: t.analysis.navigation.historicalScore, anchor: "historical-score" },
  { name: t.analysis.navigation.backtest, anchor: "backtest" },
  { name: t.analysis.navigation.top10Relevance, anchor: "top-10-relevance" },
];

export const getTrendLinks = ({ t }: { t: Translation }): NavigationLink[] => [
  { name: t.analysis.navigation.analysisInstructions, anchor: "analysis" },
  { name: t.analysis.navigation.referenceFactors, anchor: "reference-factor" },
  { name: t.analysis.navigation.historicalScore, anchor: "historical-score" },
  { name: t.analysis.navigation.backtest, anchor: "backtest" },
  { name: t.analysis.navigation.top10Relevance, anchor: "top-10-relevance" },
];

export const getSwingTradingLinks = ({
  t,
}: {
  t: Translation;
}): NavigationLink[] => [
  { name: t.analysis.navigation.analysisInstructions, anchor: "analysis" },
  { name: t.analysis.navigation.historicalScore, anchor: "historical-score" },
  { name: t.analysis.navigation.backtest, anchor: "backtest" },
  { name: t.analysis.navigation.top10Relevance, anchor: "top-10-relevance" },
];

export const getUSWhaleInterestLinks = ({
  t,
}: {
  t: Translation;
}): NavigationLink[] => [
  { name: t.analysis.navigation.analysisInstructions, anchor: "analysis" },
  { name: t.analysis.navigation.referenceFactors, anchor: "reference-factor" },
  { name: t.analysis.navigation.historicalScore, anchor: "historical-score" },
  {
    name: t.analysis.navigation.institutionHolding,
    anchor: "prominent-institution-holdings",
  },
  {
    name: t.analysis.navigation.insiderTransaction,
    anchor: "insider-transactions",
  },
  { name: t.analysis.navigation.top10Relevance, anchor: "top-10-relevance" },
];

export const getTWWhaleInterestLinks = ({
  t,
}: {
  t: Translation;
}): NavigationLink[] => [
  { name: t.analysis.navigation.analysisInstructions, anchor: "analysis" },
  { name: t.analysis.navigation.historicalScore, anchor: "historical-score" },
  {
    name: t.analysis.navigation.institutionalInvestors,
    anchor: "institutional-investors",
  },
  {
    name: t.analysis.navigation.marginTradingShortSelling,
    anchor: "retail-long-short-margin",
  },
  {
    name: t.analysis.navigation.shareholderDiversification,
    anchor: "holdings-of-investors",
  },
  {
    name: t.analysis.navigation.insiderHolding,
    anchor: "holdings-of-directors-and-supervisors",
  },
  { name: t.analysis.navigation.top10Relevance, anchor: "top-10-relevance" },
];

export const getDividendLinks = ({
  t,
}: {
  t: Translation;
}): NavigationLink[] => [
  { name: t.analysis.navigation.analysisInstructions, anchor: "analysis" },
  {
    name: t.analysis.navigation.dividendReferenceFactor,
    anchor: "reference-factor",
  },
  {
    name: t.analysis.navigation.historicalDividend,
    anchor: "historical-dividend-policy",
  },
  { name: t.analysis.navigation.top10Relevance, anchor: "top-10-relevance" },
];
